import type { CSSProperties } from 'react';
import type { AnchorRect } from '../hooks/useNonFarsiContentGate';

const VIEWPORT_PAD_PX = 12;
const GAP_ABOVE_ANCHOR_PX = 8;
const MAX_PANEL_WIDTH = 352;
const MIN_PANEL_WIDTH = 260;

/** z-index above learner slide modals (z-200). */
export const ELEVATED_HINT_Z_INDEX = 210;

export function computeAnchoredHintPanelStyle(
  anchorRect: AnchorRect,
  zIndex: number = ELEVATED_HINT_Z_INDEX
): CSSProperties {
  const maxWidth = window.innerWidth - VIEWPORT_PAD_PX * 2;
  const panelWidth = Math.min(
    MAX_PANEL_WIDTH,
    Math.max(anchorRect.width, MIN_PANEL_WIDTH),
    maxWidth
  );

  const anchorCenterX = (anchorRect.left + anchorRect.right) / 2;
  let left = anchorCenterX - panelWidth / 2;
  left = Math.max(VIEWPORT_PAD_PX, Math.min(left, window.innerWidth - panelWidth - VIEWPORT_PAD_PX));

  return {
    position: 'fixed',
    top: anchorRect.top - GAP_ABOVE_ANCHOR_PX,
    left,
    width: panelWidth,
    maxWidth: `calc(100vw - ${VIEWPORT_PAD_PX * 2}px)`,
    transform: 'translateY(-100%)',
    zIndex,
  };
}
